/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_appsync_graphqlEndpoint": "https://5vofysys5fcmlakctnnzgi7xxi.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-lppx72atgrek7hrramzqd76rty",
    "aws_cognito_identity_pool_id": "us-east-2:70ff1c96-c3d9-4f73-885d-20b050a77738",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_LL9OonqA0",
    "aws_user_pools_web_client_id": "5lf70ckkbr0t3jhdpcgtgk6p8p",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "jobify53edb77fd7b84c5b876bdd95ceaa7c504d254-dev",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
